<template>
  <Dialog
    width="678px"
    :height="createRenderType == 'mobile' ? 'unset' : 'max-content'"
    titleAlign="left"
    :title="$$t('create.edit_melody_ideas')"
    :visible="renderData.visible"
    :customClass="`edit-refer-clip-vocal-music-reference-dialog ${
      createRenderType == 'mobile'
        ? 'edit-refer-clip-vocal-music-reference-dialog-mobile'
        : ''
    }`"
    @close="onClose"
    mobileRenderType="drawerDialog"
  >
    <div
      class="height-all edit-clip-motif-music-reference flex-column"
      :class="{
        'edit-clip-motif-music-reference-mobile': createRenderType == 'mobile',
      }"
      @click.stop
    >
      <div class="edit-clip-motif-music-reference-item-label">
        {{ $$t("create.name_melody_idea") }}
        <span
          class="edit-clip-motif-music-reference-item-error fn-inline"
          v-if="!!renderDataValid.validataFilename"
        >
          ( {{ renderDataValid.validataFilename }} )
        </span>
      </div>
      <div class="edit-clip-motif-music-reference-item-edit-filename flex-row">
        <input
          :placeholder="$$t('create.melody_idea_name_placeholder')"
          class="flex1 width-0"
          :value="renderData.filename"
          @input="onInput"
          @change="onChange"
          @compositionstart="handleCompositionStart"
          @compositionend="handleCompositionEnd"
        />
        <div class="edit-clip-motif-music-reference-item-edit-filename-count">
          {{ renderData.filename.length }}/60
        </div>
      </div>

      <!-- <div class="edit-clip-motif-music-reference-item-label">Clip song</div> -->
      <div
        class="edit-clip-motif-music-reference-item-clip"
        v-if="renderData.clipSourceData"
      >
        <SkyClippingFixedDuration
          :config="{
            spacingSize: 3,
            wavebarWidth: 1,
            clipDuration: 60,
            tbPadding: 10,
          }"
          v-if="renderData.ifRender"
          ref="refClipFixedDuration"
          :clipSourceData="renderData.clipSourceData"
          :label="$$t('create.select_clip')"
          :selectResultText="$$t('create.selected_clip_duration_result')"
        >
        </SkyClippingFixedDuration>
      </div>

      <div class="edit-clip-motif-music-reference-item-btn-box">
        <div class="edit-clip-motif-music-reference-item-btn">
          <Button
            @click="onDoneClick"
            :disabled="renderData.disableDoneBtn"
            :renderStyle="{
              '--padding': '0',
              '--width': '100%',
              '--height': '48px',
              '--borderRadius': '50px',
              '--fontColor': '#000',
              '--fontSize': '16px',
              '--fontWeight': 'normal',
              '--border': 'none',
              '--background':
                'linear-gradient(120deg, rgb(79, 222, 255, 1) -1%, rgb(230, 117, 255, 1) 100%)', //#94ADFF
              '--backgroundHover':
                'linear-gradient(120deg, rgb(79, 222, 255, 0.75) -1%, rgb(230, 117, 255, 0.75) 100%)',
              '--fontColorHover': '#000',
            }"
          >
            {{ $$t("create.done") }}
          </Button>
        </div>
      </div>

      <div class="edit-clip-motif-music-reference-item-items">
        {{ disclaimerMap[$$language()].pre }}
        <a @click="openDisclaimer">{{ disclaimerMap[$$language()].link }}</a>
        {{ disclaimerMap[$$language()].end }}
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue"
import Dialog from "@/components/basic/dialog/Dialog.vue"
import ReferenceItem from "./referenceItem.vue"
import SkyClippingFixedDuration from "@/components/media/clip/ClippingFixedDuration.vue"
import validationTools from "@/utils/validationTools.js"
import { storeToRefs } from "pinia"
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"
const createLayoutStore = useCreateLayoutStore()
const { createRenderType } = storeToRefs(createLayoutStore)

const disclaimerMap = {
  en: {
    pre: "By uploading, you acknowledge and agree to the",
    link: "Disclaimer",
    end: "and allow others to use the audio.",
  },
  cn: {
    pre: "上传即代表您已知悉和同意",
    link: "《免责声明》",
    end: "，并允许他人使用该音频",
  },
  es: {
    pre: "Al subirlo, reconoces y aceptas el ",
    link: "[Descargo de responsabilidad]",
    end: "y permites que otros utilicen el audio.",
  },
  pt: {
    pre: "Ao fazer upload, você reconhece e concorda com o",
    link: "[Isenção de responsabilidade]",
    end: "e permite que outras pessoas usem o áudio.",
  },
  ko: {
    pre: "업로드함으로써 귀하는 ",
    link: "[면책 조항]",
    end: "을 인정하고 동의하며 다른 사람이 오디오를 사용하도록 허용합니다.",
  },
  ja: {
    pre: "アップロードすると、",
    link: "[免責事項]",
    end: "に同意し、他の人が音声を使用できるようになります。",
  },
  de: {
    pre: "Mit dem Hochladen erkennen Sie an und stimmen zu ",
    link: "[Haftungsausschluss]",
    end: "und erlauben es anderen, den Audio zu verwenden.",
  },
  it: {
    pre: "Caricando, accetti e acconsenti al ",
    link: "[Disclaimer]",
    end: "e permetti ad altri di utilizzare l'audio.",
  },
  fr: {
    pre: "En téléchargeant, vous reconnaissez et acceptez le ",
    link: "[Avertissement]",
    end: "et permettez à d'autres d'utiliser l'audio.",
  },
  ru: {
    pre: "Загрузив, вы признаете и соглашаетесь с ",
    link: "[Отказ от ответственности]",
    end: "и разрешаете другим использовать аудио.",
  },
  "zh-CN": {
    pre: "上传即代表您已知悉和同意",
    link: "《免责声明》",
    end: "，并允许他人使用该音频",
  },
  "zh-TW": {
    pre: "上傳即代表您已知悉和同意",
    link: "《免責聲明》",
    end: "，並允許他人使用該音頻",
  },
}

import {
  ReferStyleLabelData,
  ReferEmotionalLabelData,
  getEnOptions,
} from "@/config/const.js"
import { $$language, $$t, $$tValue } from "@/i18n/i18n.js"

const props = defineProps({
  editFileName: {
    type: String,
    default: "",
  },
  visible: {
    type: Boolean,
    default: false,
  },
  clipSourceData: {
    type: Object, // decode
    default: null,
  },
})

const emits = defineEmits(["update:visible", "complete"])

const stateData = {
  filenameRule: [
    (v) => !!v || $$t("create.this_field_is_required"),
    (v) =>
      (v.length >= 1 && v.length <= 60) ||
      $$tValue("create.song_name_max_characters", { num: 60 }),
    (v) =>
      !validationTools.containsEmoji(v) ||
      $$t("create.song_name_cannot_contain_emoji"),
    (v) =>
      !validationTools.isAllPunctuation(v) ||
      $$t("create.song_name_cannot_symbols"),
    // (v) =>
    //   /^[\u4e00-\u9fa50-9A-Za-z]+$/.test(v) || "仅支持输入“汉字、字母、数字”",
  ],
  moodOptions: getEnOptions(ReferEmotionalLabelData.list),
  styleOptions: getEnOptions(ReferStyleLabelData.list),
}

const refClipFixedDuration = ref(null)

const renderData = reactive({
  visible: props.visible,
  filename: props.editFileName ?? "",
  clipSourceData: null,
  ifRender: true,
})
const renderDataValid = reactive({
  validataFilename: "",
})
const handleCompositionStart = () => {
  renderData.inputing = true
}

const handleCompositionEnd = (e) => {
  renderData.inputing = false
  onInput(e)
}
const onInput = (e) => {
  if (!renderData.inputing) {
    if (e.target.value.length > 60) {
      e.target.value = e.target.value.slice(0, 60)
    }
    renderData.filename = e.target.value
  }
}
const onChange = (e) => {
  validMap.validataFilename(renderData.filename)
}

const validMap = {
  validataFilename: (filename) => {
    let index = stateData.filenameRule.findIndex((v) => v(filename) != true)
    if (index >= 0) {
      renderDataValid.validataFilename = stateData.filenameRule[index](filename)
      return false
    }
    renderDataValid.validataFilename = ""
    return true
  },
}
const onSelectMoodTag = (item) => {
  renderData.moodTag = item
  validMap.validataMoodTag(item)
}
const onSelectStyleTag = (item) => {
  renderData.styleTag = item
  validMap.validataStyleTag(item)
}

const onClose = () => {
  renderData.visible = false
  refClipFixedDuration.value?.pause()
  renderData.filename = ""
  emits("update:visible", false)
  emits("cancel")
}

const onDoneClick = async () => {
  let validataFilename = await validMap.validataFilename(renderData.filename)
  if (validataFilename) {
    if (
      (await refClipFixedDuration.value?.validate()) ||
      !renderData.clipSourceData
    ) {
      emits(
        "complete",
        {
          data: renderData,
          getClipedExportData: refClipFixedDuration.value?.getClipedExportData,
          getClipedTimeInfoData:
            refClipFixedDuration.value?.getClipedTimeInfoData,
        },
        () => {
          renderData.filename = ""
          refClipFixedDuration.value?.pause()
          renderData.visible = false
          emits("update:visible", false)
        }
      )
    } else {
      console.log("裁剪还未准备就绪")
    }
  }
}

const openDisclaimer = () => {
  window.open(window.location.origin + "/disclaimer", "_blank")
}

watch(
  () => props.visible,
  (val) => {
    renderData.visible = props.visible
  }
)

watch(
  () => renderData.visible,
  (val) => {
    emits("update:visible", val)
    if (val) {
      nextTick().then(() => {
        renderData.clipSourceData = props.clipSourceData
        renderData.filename = props.editFileName ?? ""
      })
    }
  }
)
watch(
  () => props.clipSourceData,
  (newValue, oldValue) => {
    nextTick().then(() => {
      renderData.clipSourceData = props.clipSourceData
    })
  }
)

onMounted(() => {})
onUnmounted(() => {})
</script>
<style lang="scss">
.custom-dialog.edit-refer-clip-vocal-music-reference-dialog {
  .dialog-box {
    padding: 40px 20px 40px 20px;
  }
  .dialog-header {
    padding: 0 20px;
  }
  .dialog-close {
    width: 36px;
    height: 36px;
    line-height: 36px;
    position: absolute;
    top: 30px;
    right: 30px;
  }
}
.custom-dialog.edit-refer-clip-vocal-music-reference-dialog-mobile {
  .dialog-box {
    padding: 16px 16px 16px 16px;
  }
  .dialog-content {
    overflow-x: hidden;
  }
  .dialog-header {
    padding: 0 0px;
  }
  .dialog-close {
    width: 36px;
    height: 36px;
    line-height: 36px;
    position: absolute;
    top: 16px;
    right: 16px;
  }
}
.edit-clip-motif-music-reference {
  padding: 15px 0 0px 0;
  .edit-clip-motif-music-reference-item-label {
    padding: 0 20px;
    font-family: HarmonyOS Sans SC;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
    height: 20px;
    color: #ffffff;
    margin-bottom: 8px;
    .edit-clip-motif-music-reference-item-error {
      color: #ff5f74;
    }
  }
  .edit-clip-motif-music-reference-item-edit-filename {
    height: 36px;
    min-height: 36px;
    border-radius: 8px;
    padding: 0 12px;
    margin: 0 20px 20px 20px;
    background: rgba(255, 255, 255, 0.1);
    align-items: center;
    input {
      height: 100%;
      width: 100%;
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: normal;
      line-height: 20px;
      background: transparent;
      border: none;
      outline: none;

      color: #ffffff;
      &::placeholder {
        color: rgba(255, 255, 255, 0.5) !important;
      }
    }
    .edit-clip-motif-music-reference-item-edit-filename-count {
      font-size: 12px;
      font-weight: normal;
      line-height: 20px;
      color: rgba(255, 255, 255, 0.5);
      margin: 0 0 0 12px;
    }
  }
  .edit-clip-motif-music-reference-desc {
    font-family: HarmonyOS Sans SC;
    font-size: 12px;
    font-weight: normal;
    line-height: 16px;
    color: rgba(255, 255, 255, 0.5);
    margin: 0 20px 4px 20px;
    &:last-child {
      margin: 0 20px 20px 20px;
    }
  }
  .edit-clip-motif-music-reference-item-clip {
  }
  .edit-clip-motif-music-reference-item-items {
    margin: 20px 0 0px 0;
    padding: 0 20px;
    font-family: HarmonyOS Sans SC;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    color: rgba(255, 255, 255, 0.5);
    a {
      color: #fff;
    }
    a:hover {
      color: #94adff;
    }
  }
  .edit-clip-motif-music-reference-item-btn-box {
    margin: 20px 20px 0px 20px;
    .edit-clip-motif-music-reference-item-btn {
      width: 100%;
      margin: 0 auto;
    }
  }
  &.edit-clip-motif-music-reference-mobile {
    margin: 0 -20px 0 -20px;
    .edit-clip-motif-music-reference-item-btn-box {
      margin: 20px 20px 0px 20px;
      .edit-clip-motif-music-reference-item-btn {
        width: 100%;
        margin: 0 auto;
      }
    }
  }
}
</style>
